import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../../../styles/Layout/_MakePayment.scss";
import { fDate } from "../../../utils/formatTime";
// import { fDate } from "../../../utils/formatTime";

const MakePaymentTable = (props) => {
  return (
    <>
      {/* for web preview */}
      <div className="print-web">
        <div className="make-payment--tableBox">
          <TableContainer component={Paper} className="make-payment--tablewrap">
            <Table
              // sx={{ minWidth: 100 }}
              aria-label="simple table"
              className="make-payment--table"
            >
              <TableHead className="make-payment--tableHead">
                <TableRow>
                  <TableCell>Qualification Type</TableCell>
                  <TableCell align="left">Name of Degree</TableCell>
                  <TableCell align="left">University / Board State</TableCell>
                  <TableCell align="left">University / Board</TableCell>
                  <TableCell align="left">
                    Date of Issuing Final Year Marksheet
                  </TableCell>
                  <TableCell align="left">Subject / Stream</TableCell>
                  <TableCell align="left">Marks Type</TableCell>
                  <TableCell align="left">Marks Obtained / CGPA / CPI</TableCell>
                  <TableCell align="left">Maximum Marks / CGPA / CPI</TableCell>
                  <TableCell align="left">Grade Obtained</TableCell>
                  <TableCell align="left">
                    Percentage of Marks Obtained / Equivalent
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props?.data?.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {row?.qualification}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row?.degree}
                    </TableCell>
                    <TableCell align="left">{row?.state}</TableCell>
                    <TableCell align="left">{row?.universityBoard}</TableCell>
                    {/* <TableCell align="left">{(row?.qualification_id === 1 || row?.qualification_id === 6) ? fDate(row?.issuing_date, "yyyy") : fDate(row?.issuing_date, "dd/MM/yyyy")}</TableCell> */}
                    <TableCell align="left">{row?.issuing_date}</TableCell>
                    <TableCell align="left">
                      {row?.subject}
                      {row?.secondSubject ? `,${row?.secondSubject}` : ""}
                      {row?.thirdsubject ? `,${row?.thirdsubject}` : ""}
                    </TableCell>
                    {/* <TableCell align="left">{row?.subject}, {row?.secondSubject}, {row?.thirdsubject}</TableCell> */}

                    <TableCell align="left">{row?.marksTypes}</TableCell>
                    <TableCell align="left">
                      {" "}
                      {row?.marks_obtained
                        ? Number(row?.marks_obtained) === 0
                          ? "-"
                          : row?.marks_obtained
                        : "-"}
                    </TableCell>
                    <TableCell align="left">
                      {row?.maximum_marks
                        ? Number(row?.maximum_marks) === 0
                          ? "-"
                          : row?.maximum_marks
                        : "-"}
                    </TableCell>
                    <TableCell align="left">
                      {row?.grade ? row?.grade : "-"}
                    </TableCell>
                    <TableCell align="left">
                      {row?.percentage_marks_obtained
                        ? Number(row?.percentage_marks_obtained) === 0
                          ? "-"
                          : row?.percentage_marks_obtained
                        : "-"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
      {/* for print preview */}
      <div className="print-view">
        <div className="print--tableBox">
          <table className="print--table">
            <thead className="print--tableHead">
              <tr>
                <th>Qualification Type</th>
                <th>Name of Degree</th>
                <th>University / Board State</th>
                <th>University / Board</th>
                <th>Date of Issuing Final Year Marksheet</th>
                <th>Subject / Stream</th>
                <th>Marks Type</th>
                <th>Marks Obtained / CGPA / CPI</th>
                <th>Maximum Marks / CGPA / CPI</th>
                <th>Grade Obtained</th>
                <th>Percentage of Marks Obtained / Equivalent</th>
              </tr>
            </thead>
            <tbody>
              {props?.data?.map((row, index) => (
                <tr key={index}>
                  <td>{row?.qualification}</td>
                  <td>{row?.degree}</td>
                  <td>{row?.state}</td>
                  <td>{row?.universityBoard}</td>
                  <td>{row?.issuing_date}</td>
                  <td>
                    {row?.subject}
                    {row?.secondSubject ? `,${row?.secondSubject}` : ""}
                    {row?.thirdsubject ? `,${row?.thirdsubject}` : ""}
                  </td>
                  <td>{row?.marksTypes}</td>
                  <td>
                    {row?.marks_obtained
                      ? Number(row?.marks_obtained) === 0
                        ? "-"
                        : row?.marks_obtained
                      : "-"}
                  </td>
                  <td>
                    {row?.maximum_marks
                      ? Number(row?.maximum_marks) === 0
                        ? "-"
                        : row?.maximum_marks
                      : "-"}
                  </td>
                  <td>{row?.grade ? row?.grade : "-"}</td>
                  <td>
                    {row?.percentage_marks_obtained
                      ? Number(row?.percentage_marks_obtained) === 0
                        ? "-"
                        : row?.percentage_marks_obtained
                      : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default MakePaymentTable;
